import { useContext } from 'react';

import { SurveyLanguageContext } from 'context/surveyLanguage/SurveyLanguageContext';

export const useSurveyLanguage = () => {
  const context = useContext(SurveyLanguageContext);

  if (context === undefined) {
    throw new Error('SurveyLanguageContext must be within SurveyLanguageProvider');
  }

  return context;
};
